import Selector from './Selector';

export default Selector;
export { Selector };
export type { SelectorValue, SelectorProps, SelectorOption } from './type';
